'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { bannerActionRecipe } from './styles/banner-action.styles';
import type { BannerActionPropsInterface } from './types/banner-action.types';

/**
 * @since 10.0.0
 */

export const BannerAction = forwardRef<HTMLDivElement, BannerActionPropsInterface>(
  (props, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(bannerActionRecipe, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Banner.Action"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_banner__action', styles, className)}
        {...rest}
      />
    );
  },
);

BannerAction.displayName = 'Banner.Action';
